import {Layout, LayoutProps} from '@di-nxt/components';
import React from 'react';

type Props = Omit<LayoutProps, 'overflow' | 'pointerEvents'>;

export const CellSpanContainer: React.FC<Props> = ({children, ...props}) => {
  return (
    <Layout flex overflow="hidden" pointerEvents={'auto'} {...props}>
      {children}
    </Layout>
  );
};
